import { combineReducers } from 'redux';
import { getUserListReducer } from '../user/user-reducers';
import { FETCH_ADMIN_LIST } from './admin-actions';

export default combineReducers({
  list: getUserListReducer(FETCH_ADMIN_LIST),
});
